module.exports = __webpack_public_path__ + "img/Apoptosis-MELA_SpatialResearch.60892a8e.png";